module.exports = __webpack_public_path__ + "03_short_yellow.ff4cb2e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_short_yellow.png
// module id = eliY
// module chunks = 0